<template>
  <span>
    <b-button v-if="isCreateMode"
              type="button"
              variant="success"
              @click="toggle"
    ><i class="fas fa-plus"></i> Create</b-button>

    <b-button v-else variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>

    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group v-if="isCreateMode" label="Partner" label-for="partner-input">
          <multiselect id="partner-input"
                       v-model="chosenPartner"
                       :options="partnerOptions"
                       :loading="partnersLoading"
                       track-by="value"
                       label="label"
                       placeholder="Select partner"
          ></multiselect>
        </b-form-group>
        <b-form-group v-else label="Partner" label-for="partner-name-input">
          <b-form-input id="partner-name-input" :value="token.partnerName || 'unknown'" readonly></b-form-input>
        </b-form-group>

        <b-form-group label="Brand ID" label-for="brand-id-input">
          <b-form-input id="brand-id-input"
                        v-model="tokenForm.brandId"
                        :readonly="!isCreateMode"
                        autocomplete="off"
                        :required="isCreateMode"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Alt Token" label-for="alt-token-input" :description="secretFieldDescription">
          <b-form-input id="alt-token-input"
                        v-model="tokenForm.altToken"
                        class="secret-input"
                        autocomplete="off"
                        :required="isCreateMode"
                        :placeholder="isCreateMode ? '' : 'Leave empty to keep current value'"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Alt Secret" label-for="alt-secret-input" :description="secretFieldDescription">
          <b-form-input id="alt-secret-input"
                        v-model="tokenForm.altSecret"
                        class="secret-input"
                        autocomplete="off"
                        :required="isCreateMode"
                        :placeholder="isCreateMode ? '' : 'Leave empty to keep current value'"
          ></b-form-input>
        </b-form-group>
      </form>
      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import Multiselect from 'vue-multiselect';

const MODE_CREATE = 'create';

export default {
  data() {
    return {
      tokenForm: {},
      chosenPartner: null,
      partnerOptions: [],
      partnersLoading: false,
      partnersLoaded: false,
      isCreateMode: true,
      modalShow: false,
    }
  },
  components: {
    Multiselect,
  },
  props: [
    'token',
    'mode',
  ],
  methods: {
    checkFormValidity() {
      return this.$refs.form.checkValidity();
    },
    resetModal() {
      this.chosenPartner = null;
      this.tokenForm = {
        brandId: this.token.brandId,
        altToken: '',
        altSecret: '',
      }
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;

      if (this.modalShow && this.isCreateMode) {
        this.loadPartners();
      }
    },
    loadPartners() {
      if (this.partnersLoaded || this.partnersLoading) {
        return;
      }

      this.partnersLoading = true;

      this
        .$http({
          url: '/api/v1/alt-ss-brand-tokens/partners-for-select',
          method: 'GET',
        })
        .then(resp => {
          this.partnerOptions = resp.data;
          this.partnersLoaded = true;
        })
        .catch((err) => {
          this.$toastr.e('Failed to load partners');
          throw err;
        })
        .finally(() => {
          this.partnersLoading = false;
        });
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        this.$refs.form.reportValidity();
        return;
      }

      if (this.isCreateMode && !this.chosenPartner) {
        this.$toastr.e('Please select a partner');
        return;
      }

      if (!this.isCreateMode && !this.tokenForm.altToken && !this.tokenForm.altSecret) {
        this.$toastr.e('Provide a new Alt Token and/or Alt Secret');
        return;
      }

      const data = this.isCreateMode
        ? {
            partnerId: this.chosenPartner.value,
            brandId: this.tokenForm.brandId,
            altToken: this.tokenForm.altToken,
            altSecret: this.tokenForm.altSecret,
          }
        : {
            altToken: this.tokenForm.altToken ? this.tokenForm.altToken : null,
            altSecret: this.tokenForm.altSecret ? this.tokenForm.altSecret : null,
          };

      this
        .$http({
          url: this.isCreateMode ? '/api/v1/alt-ss-brand-tokens' : '/api/v1/alt-ss-brand-tokens/' + this.token.id,
          data: data,
          method: this.isCreateMode ? 'POST' : 'PUT'
        })
        .then(() => {
          setTimeout(() => {
            this.$emit('finish')
          }, 500);

          this.hideModal();
          this.$toastr.i('Success');
        })
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));

          throw err;
        });
    },
  },
  computed: {
    title() {
      if (this.isCreateMode) {
        return 'Create alt SoftSwiss keys';
      } else {
        return 'Edit alt SoftSwiss keys';
      }
    },
    secretFieldDescription() {
      return this.isCreateMode ? '' : 'Current value is hidden for security reasons';
    },
  },
  mounted() {
    this.isCreateMode = this.mode === MODE_CREATE;
  },
}
</script>

<style scoped>
/* text-security instead of type="password" so the browser's password
   manager never offers to save these values */
.secret-input {
  -webkit-text-security: disc;
}
</style>
